import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Users20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.25 8.25C7.884 8.25 9.25 6.884 9.25 5.25C9.25 3.616 7.884 2.25 6.25 2.25C4.616 2.25 3.25 3.616 3.25 5.25C3.25 6.884 4.616 8.25 6.25 8.25ZM6.25 3.75C7.067 3.75 7.75 4.433 7.75 5.25C7.75 6.067 7.067 6.75 6.25 6.75C5.433 6.75 4.75 6.067 4.75 5.25C4.75 4.433 5.433 3.75 6.25 3.75Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.5 4.75C11.7298 4.75 10.25 6.22983 10.25 8C10.25 9.77017 11.7298 11.25 13.5 11.25C15.2702 11.25 16.75 9.77017 16.75 8C16.75 6.22983 15.2702 4.75 13.5 4.75ZM13.5 6.25C14.4532 6.25 15.25 7.04683 15.25 8C15.25 8.95317 14.4532 9.75 13.5 9.75C12.5468 9.75 11.75 8.95317 11.75 8C11.75 7.04683 12.5468 6.25 13.5 6.25Z'
      fill='currentColor'
    />
    <path
      d='M7.25 15C7.25 13.4812 8.48122 12.25 10 12.25H17C18.5188 12.25 19.75 13.4812 19.75 15V18H18.25V15C18.25 14.3096 17.6904 13.75 17 13.75H10C9.30964 13.75 8.75 14.3096 8.75 15V18H7.25V15Z'
      fill='currentColor'
    />
    <path
      d='M3 9.25C1.48122 9.25 0.25 10.4812 0.25 12V15H1.75V12C1.75 11.3096 2.30964 10.75 3 10.75H9V9.25H3Z'
      fill='currentColor'
    />
  </Svg>
);

Users20.displayName = 'Users20';
export default Users20;
